import React from "react";
import { graphql } from "gatsby";

import Layout from "../../components/Layout";
import ArticleCard from "../../components/ArticleCard";
import WithI18next from "../../components/WithI18next";

const AnnouncementsPage = ({ data, t }) => {
  return (
    <Layout
      title={t("announcements.seo.title")}
      description={t("announcements.seo.description")}
    >
      <div id="announcements" className="pt-5">
        <div className="container my-5 page-content">
          <h1 className="text-center mb-5">{t("announcements.title")}</h1>

          <div className="row">
            {data.allWpPost.edges.map(({ node }, i) => (
              <div
                className="col-sm-6 col-lg-4 mb-4 d-flex align-items-stretch"
                key={`announcement-item-${i}`}
              >
                <ArticleCard
                  title={node.title}
                  excerpt={node.excerpt}
                  date={node.date}
                  featuredImageNode={node.featuredImage?.node}
                  linkText={<span>{t("common.readMore")} &#187;</span>}
                  linkTo={`/announcements/${node.slug}/`}
                  footerBorder="border-1"
                  isTextTruncated={false}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default WithI18next()(AnnouncementsPage);

export const query = graphql`
  query ($wpLocale: String!, $wpGlobalConfig: String!) {
    allWpPost(
      filter: {
        categories: { nodes: { elemMatch: { slug: { eq: "announcements" } } } }
        acfGlobalConfiguration: { gcLinkTo: { in: [".all", $wpGlobalConfig] } }
        language: { locale: { eq: $wpLocale } }
      }
      sort: { order: DESC, fields: date }
    ) {
      edges {
        node {
          title
          excerpt
          slug
          date(formatString: "MMMM DD, YYYY")
          featuredImage {
            node {
              localFile {
                childImageSharp {
                  gatsbyImageData(width: 450, layout: CONSTRAINED)
                }
              }
            }
          }
        }
      }
    }
  }
`;
